"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _featured_content_card = require("./featured_content_card.js");

var _featured_content_card2 = _interopRequireDefault(_featured_content_card);

var _fund_facts_card = require("./fund_facts_card.js");

var _fund_facts_card2 = _interopRequireDefault(_fund_facts_card);

var _fund_managers_card = require("./fund_managers_card.js");

var _fund_managers_card2 = _interopRequireDefault(_fund_managers_card);

var _fund_stats_card = require("./fund_stats_card.js");

var _fund_stats_card2 = _interopRequireDefault(_fund_stats_card);

var _board_of_directors_card = require("./board_of_directors_card");

var _board_of_directors_card2 = _interopRequireDefault(_board_of_directors_card);

var _lipper_ratings = require("./lipper_ratings.js");

var _lipper_ratings2 = _interopRequireDefault(_lipper_ratings);

var _minimum_investments_card = require("./minimum_investments_card.js");

var _minimum_investments_card2 = _interopRequireDefault(_minimum_investments_card);

var _morningstar_ratings = require("./morningstar_ratings.js");

var _morningstar_ratings2 = _interopRequireDefault(_morningstar_ratings);

var _objective_card = require("./objective_card.js");

var _objective_card2 = _interopRequireDefault(_objective_card);

var _risk_indicator_card = require("./risk_indicator_card.js");

var _risk_indicator_card2 = _interopRequireDefault(_risk_indicator_card);

var _generic_objective_card = require("./generic_objective_card.js");

var _generic_objective_card2 = _interopRequireDefault(_generic_objective_card);

var _card_component = require("./global_components/card_component.js");

var _card_component2 = _interopRequireDefault(_card_component);

var _fund_video = require("./fund_video.js");

var _fund_video2 = _interopRequireDefault(_fund_video);

var _ramda = require("ramda");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _constants = require("../../../packages/common-utilities/src/constants.js");

var _constants2 = _interopRequireDefault(_constants);

var _reactIntl = require("react-intl");

var _charges_card = require("./charges_card");

var _charges_card2 = _interopRequireDefault(_charges_card);

var _fund_financial_calendar_card = require("./fund_financial_calendar_card");

var _fund_financial_calendar_card2 = _interopRequireDefault(_fund_financial_calendar_card);

var _fund_awards_and_ratings_card = require("./fund_awards_and_ratings_card");

var _fund_awards_and_ratings_card2 = _interopRequireDefault(_fund_awards_and_ratings_card);

var _registered_country_component = require("./registered_country_component");

var _registered_country_component2 = _interopRequireDefault(_registered_country_component);

var _exchanges_card = require("./exchanges_card");

var _exchanges_card2 = _interopRequireDefault(_exchanges_card);

var _fund_utility = require("../../../packages/common-utilities/src/fund_utility");

var _key_risks_card = require("./key_risks_card");

var _key_risks_card2 = _interopRequireDefault(_key_risks_card);

var _fund_webcast = require("./fund_webcast");

var _fund_webcast2 = _interopRequireDefault(_fund_webcast);

var _functional_utility = require("../../../packages/common-utilities/src/functional_utility");

var _portfolio_insights = require("./portfolio_insights");

var _portfolio_insights2 = _interopRequireDefault(_portfolio_insights);

var _party_role_name_listing_card = require("./party_role_name_listing_card");

var _party_role_name_listing_card2 = _interopRequireDefault(_party_role_name_listing_card);

var _location_service = require("../services/location_service");

var _location_service2 = _interopRequireDefault(_location_service);

var _fund_charges = require("./fund_charges");

var _fund_charges2 = _interopRequireDefault(_fund_charges);

var _string_utility = require("../../../packages/common-utilities/src/string_utility");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _fund_carbon_emissions = require("./fund_carbon_emissions");

var _fund_carbon_emissions2 = _interopRequireDefault(_fund_carbon_emissions);

var _collection_utility = require("common-utilities/src/collection_utility");

var _sanitize_utility = require("common-utilities/src/sanitize_utility");

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _moment = require("moment/moment");

var _moment2 = _interopRequireDefault(_moment);

var _date_formatter = require("common-utilities/src/date_formatter");

var _how_to_invest_card = require("./how_to_invest_card");

var _how_to_invest_card2 = _interopRequireDefault(_how_to_invest_card);

var _carousel = require("./carousel/carousel");

var _carousel2 = _interopRequireDefault(_carousel);

var _sample_withdrawal_card = require("./sample_withdrawal_card");

var _sample_withdrawal_card2 = _interopRequireDefault(_sample_withdrawal_card);

var _distributor_table_component = require("./distributor_table_component");

var _distributor_table_component2 = _interopRequireDefault(_distributor_table_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FundOverview = function (_React$Component) {
  _inherits(FundOverview, _React$Component);

  function FundOverview(props) {
    _classCallCheck(this, FundOverview);

    var _this = _possibleConstructorReturn(this, (FundOverview.__proto__ || Object.getPrototypeOf(FundOverview)).call(this, props));

    _this.shouldRenderSampleWithdrawal = function () {
      var sampleWithdrawalAmountDp = (0, _ramda.pathOr)(null, ['fund', 'breakdowns', 'sampleWithdrawalAmountDp'], _this.props);
      if ((0, _ramda.isNil)(sampleWithdrawalAmountDp) || (0, _ramda.isNil)(sampleWithdrawalAmountDp.date) || (0, _ramda.isNil)(sampleWithdrawalAmountDp.displayValue)) {
        return false;
      }
      return (0, _moment2.default)(sampleWithdrawalAmountDp.date).isValid();
    };

    _this.renderSampleWithdrawalCard = function () {
      return _react2.default.createElement(_sample_withdrawal_card2.default, {
        disclosure: _this.props.fund.disclosures,
        breakpoint: _this.props.breakpoint,
        tooltip: _this.props.tooltip,
        country: _this.props.country,
        intl: _this.props.intl,
        role: _this.props.role,
        fund: _this.props.fund,
        showHeaderIcon: true
      });
    };

    _this.renderInvestmentOnRiskCard = function () {
      var content = (0, _ramda.pathOr)(null, ["disclosures", "pdpCardInvestmentRisk"], _this.props.fund);
      var paddingLeft = "padding-left-0";
      var paddingRight = "padding-right-0";
      var title = _string_utility2.default.renderFormattedLabel("Investment Risk", "pdp-investment-risk-label");

      return _collection_utility.CollectionUtility.includes((_this.props.fund.visibleData || {}).visibleDataPoints, 'INVESTMENT_ON_RISK_CARD') && !(0, _ramda.isNil)(content) ? _react2.default.createElement(
        _card_component2.default,
        {
          headerTitle: title,
          headerTitleId: "investment-risk-card",
          headerTitleLabel: "investment-risk-card",
          dataTest: "investment-risk-card",
          headerLabel: "",
          breakpoint: _this.props.breakpoint,
          disclosureText: _this.props.fund.disclosures.pdpCardRisk,
          placementId: "pdpCardRisk" },
        _react2.default.createElement("div", {
          className: "border-warm-grey tag-2 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 " + paddingLeft + " " + paddingRight,
          "data-testid": "investment-on-risk-disclosure",
          id: "investment-on-risk-text",
          style: { 'line-height': '1.43' },
          dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(content) } })
      ) : null;
    };

    _this.renderDividendPolicyCard = function () {
      var title = _string_utility2.default.renderFormattedLabel("Dividend Policy", "pdp-dividend-policy-label");
      var content = _string_utility2.default.renderFormattedLabel("請參考基金公開說明書", "pdp-dividend-policy-content", { fundType: _this.props.fund.fundTypeCode });

      return _collection_utility.CollectionUtility.includes(_this.props.fund.visibleData.visibleDataPoints, "SHOW_DIVIDEND_POLICY_CARD") && _react2.default.createElement(
        _card_component2.default,
        {
          headerTitle: title,
          headerTitleId: "dividend-policy-card",
          headerTitleLabel: "dividend-policy-card",
          dataTest: "dividend-policy-card",
          headerLabel: "",
          breakpoint: _this.props.breakpoint },
        _react2.default.createElement(
          "div",
          {
            className: "border-warm-grey tag-2 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12",
            "data-testid": "dividend-policy-text",
            id: "dividend-policy-text",
            style: { 'line-height': '1.43' } },
          content
        )
      );
    };

    _this.renderTrustInBriefCarousel = function () {

      if (!_collection_utility.CollectionUtility.includes(_this.props.fund.visibleData.visibleDataPoints, 'SHOW_OVERVIEW_TRUST_IN_BRIEF')) {
        return null;
      }

      var cusip = (0, _functional_utility.pathOrNull)(['fund', 'shareClass', 'cusip'], _this.props);
      var trustInBrief = (0, _functional_utility.pathOrNull)(['content', 'trustInBrief', cusip, 0], _this.props);

      if ((0, _functional_utility.isNilOrEmpty)(trustInBrief)) {
        return null;
      }

      var templates = trustInBrief.slideTemplate || [];
      var validSlideTypes = Object.values(_carousel.SlideType);
      var slides = templates.filter(function (template) {
        return validSlideTypes.includes(template.slideType);
      }).slice(0, 5);

      return _react2.default.createElement(
        "div",
        {
          "data-testid": 'trust-in-brief',
          className: 'background-white pdp-tab-card-container print-page-break margin-bottom-32' },
        _react2.default.createElement(_carousel2.default, {
          key: "carousel-overview-" + _this.props.active,
          loop: true,
          autoHeight: true,
          slidesPerView: 1,
          spaceBetween: 20,
          headerContent: trustInBrief.title,
          slides: slides,
          breakpoint: _this.props.breakpoint,
          window: _this.props.window,
          pauseVideos: _this.props.active !== "overview"
        })
      );
    };

    _location_service2.default.setTargetWindowObject(props.window);
    return _this;
  }

  _createClass(FundOverview, [{
    key: "isValueNoMinimum",
    value: function isValueNoMinimum(value) {
      if ((0, _ramda.isNil)(value) || -2 === parseInt(value, 10) || 0 === parseInt(value, 10)) {
        return true;
      }
    }
  }, {
    key: "showMinimumInvestmentsCard",
    value: function showMinimumInvestmentsCard() {
      if (!(0, _fund_utility.isUSEtfFund)(this.props.country, this.props.fund.fundTypeCode)) {
        if (this.props.fund.fundTypeCode !== 'Commingled' && this.nonCommingledCheck()) {
          return null;
        } else if (this.props.fund.fundTypeCode === 'Commingled' && this.commingledCheck()) {
          return null;
        }

        if (!_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'MINIMUM_INVESTMENTS_IRA') && !_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, "MINIMUM_INVESTMENTS_REGULAR")) {
          return null;
        }

        return _react2.default.createElement(_minimum_investments_card2.default, {
          minimumInvestments: this.props.fund.shareClass.minimumInvestments,
          currencyCode: this.props.fund.shareClass.currencyCode,
          country: this.props.country,
          role: this.props.role,
          language: this.props.language,
          visibleDataPoints: this.props.fund.visibleData.visibleDataPoints,
          breakpoint: this.props.breakpoint,
          disclosure: this.props.fund.disclosures.pdpCardMinimumInvestmentBelgium,
          numberFormat: this.props.fund.numberFormat });
      }
    }
  }, {
    key: "showFundChargesCard",
    value: function showFundChargesCard() {
      if (!_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'FUND_CHARGES')) {
        return null;
      }

      return _react2.default.createElement(_fund_charges2.default, {
        disclosures: this.props.fund.disclosures,
        currencyCode: this.props.fund.shareClass.currencyCode,
        fees: this.props.fund.shareClass.fees,
        investmentLimitAmount: this.props.fund.shareClass.minimumInvestments.investmentLimitAmount,
        visibleData: this.props.fund.visibleData
      });
    }
  }, {
    key: "nonCommingledCheck",
    value: function nonCommingledCheck() {
      if (!(0, _ramda.isNil)(this.props.fund.shareClass.minimumInvestments) && this.isValueNoMinimum(this.props.fund.shareClass.minimumInvestments.iraInvestments) && this.isValueNoMinimum(this.props.fund.shareClass.minimumInvestments.iraSubsequentInvestments) && this.isValueNoMinimum(this.props.fund.shareClass.minimumInvestments.regularInvestments) && this.isValueNoMinimum(this.props.fund.shareClass.minimumInvestments.regularSubsequentInvestments)) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "commingledCheck",
    value: function commingledCheck() {
      if (!(0, _ramda.isNil)(this.props.fund.shareClass.minimumInvestments) && this.isValueNoMinimum(this.props.fund.shareClass.minimumInvestments.iraInvestments) && this.isValueNoMinimum(this.props.fund.shareClass.minimumInvestments.iraSubsequentInvestments)) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "renderFundFactsCard",
    value: function renderFundFactsCard() {
      return _react2.default.createElement(_fund_facts_card2.default, {
        cusip: this.props.fund.shareClass.cusip,
        ticker: this.props.fund.shareClass.ticker,
        isin: this.props.fund.shareClass.isin,
        iressTicker: this.props.fund.shareClass.iressTicker,
        exchangeTicker: this.props.fund.shareClass.exchangeTicker,
        domicile: this.props.fund.domicile,
        shareclassNumber: this.props.fund.shareClass.shareclassNumber,
        tradingInfo: this.props.fund.shareClass.tradingInfo,
        listingDate: this.props.fund.shareClass.listingDate,
        fundNumber: this.props.fund.fundNumber,
        assetClass: this.props.fund.assetClass,
        fundInceptionDate: this.props.fund.fundInceptionDate,
        dateOfAgreement: this.props.fund.dateOfAgreement,
        shareClassInceptionDate: this.props.fund.shareClass.shareClassInceptionDate,
        mmfType: this.props.fund.emeaFundClassificationName,
        shareClassCutOffTime: this.props.fund.shareClass.cutOffTime,
        shareClassCutOffTimeZone: this.props.fund.shareClass.cutOffTimeZone,
        fundCutOffTime: this.props.fund.cutOffTime,
        fundCutOffTimeZone: this.props.fund.cutOffTimeZone,
        fundTypeCode: this.props.fund.fundTypeCode,
        disclosure: this.props.fund.disclosures,
        breakpoint: this.props.breakpoint,
        visibleData: this.props.fund.visibleData,
        tooltip: this.props.tooltip,
        shareclassCurrencyCode: this.props.fund.shareClass.currencyCode,
        sedolCode: this.props.fund.shareClass.sedolCode,
        reutersInstrumentCode: this.props.fund.shareClass.reutersInstrumentCode,
        viivTicker: this.props.fund.shareClass.viivTicker,
        regionOfInvestment: this.props.fund.regionOfInvestmentCode,
        currencyCode: this.props.fund.currencyCode,
        hedgedShareclassIndicator: this.props.fund.shareClass.hedgedShareclassIndicator,
        fundValuationFrequency: this.props.fund.fundValuationFrequency,
        settlementCycleRedemptionName: this.props.fund.shareClass.settlementCycleRedemptionName,
        legalStructureCode: this.props.fund.legalStructureCode,
        country: this.props.country,
        distributionFrequency: this.props.fund.shareClass.distributionFrequency,
        distributionDate: this.props.fund.shareClass.distributionDate,
        riskLevel: this.props.fund.riskLevel,
        riskRatingValue: _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.formattingRules, 'CA_ETF_FUND_FACTS_CARD') ? this.props.fund.shareClass.fundRiskRatingValue : this.props.fund.riskRatingValue,
        isUkSDRCategorisation: (0, _ramda.pathOr)(null, ["fund", "stringValueWrapper", "ukSdrCategorisation"], this.props),
        valoren: this.props.fund.shareClass.valoren,
        redemptionSettlementDate: this.props.fund.shareClass.redemptionSettlementDate,
        dealingFrequency: this.props.fund.shareClass.dealingFrequency,
        trustee: this.props.fund.trustee,
        fiscalYearEnd: this.props.fund.fiscalYearEnd,
        intl: this.props.intl,
        idExists: !!this.props.intl.messages["pdp-fund-facts-distribution-frequency-" + this.props.fund.shareClass.distributionFrequency] || _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.formattingRules, 'CA_ETF_FUND_FACTS_CARD'),
        role: this.props.role,
        distributingCode: this.props.fund.shareClass.distributingCode,
        valuationTimezoneName: this.props.fund.valuationTimezoneName,
        benchmarkNames: this.props.fund.benchmarkNames,
        wkn: this.props.fund.shareClass.wknCode,
        newspaperShortName: this.props.fund.shareClass.newspaperShortName,
        liquidationDate: this.props.fund.liquidationDate,
        fundCompany: this.props.fund.fundCompany,
        offerPrice: this.props.fund.shareClass.shareclassLaunchPrice,
        shouldAlwaysShowMore: _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'ALWAYS_SHOW_MORE_DISCLOSURES') || _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_MORE_DISCLOSURES_FUND_FACTS'),
        isSMA: this.props.fund.isSMA,
        companyBrokerNames: this.props.fund.companyBrokerNames,
        totalAnnualDividend: this.props.fund.totalAnnualDividend,
        potentialGearingRange: this.props.fund.potentialGearingRange,
        actualGearing: (0, _ramda.isNil)(this.props.fund.shareClass.nav) ? null : this.props.fund.shareClass.nav.gearingPercentage,
        marketPrice: this.props.fund.shareClass.marketPrice,
        content: this.props.content,
        basePath: this.props.basePath,
        userLoggedIn: this.props.userLoggedIn,
        window: this.props.window,
        isAEM: this.props.isAEM,
        fund: this.props.fund
      });
    }
  }, {
    key: "renderFinancialCalendarCard",
    value: function renderFinancialCalendarCard() {

      if ((0, _ramda.isNil)(this.props.fund.visibleData.visibleFinancialCalendar) || this.props.fund.visibleData.visibleFinancialCalendar.length === 0) {
        return null;
      }
      return _react2.default.createElement(_fund_financial_calendar_card2.default, {
        visibleFinancialCalendar: this.props.fund.visibleData.visibleFinancialCalendar,
        interimResultsAnnouncedPeriod: this.props.fund.interimResultsAnnouncedPeriod,
        finalResultsAnnouncedPeriod: this.props.fund.finalResultsAnnouncedPeriod,
        annualGeneralMeetingPeriod: this.props.fund.annualGeneralMeetingPeriod,
        fiscalYearEnd: this.props.fund.fiscalYearEnd,
        dividendsPayable: this.props.fund.dividendsPayable,
        disclosure: this.props.fund.disclosures,
        breakpoint: this.props.breakpoint
      });
    }
  }, {
    key: "renderFundAwardsAndRatingsCard",
    value: function renderFundAwardsAndRatingsCard(key) {

      if (!_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_ADDITIONAL_RATINGS_AND_AWARDS')) {
        return null;
      }

      var fundAwards = (0, _functional_utility.isNilOrEmpty)(this.props.content) ? null : this.props.content.awards;

      if ((0, _functional_utility.isNilOrEmpty)(fundAwards) && (0, _functional_utility.isNilOrEmpty)(this.props.additionalRatings) && ((0, _functional_utility.isNilOrEmpty)(this.props.fund.fundPerformanceRatings) || (0, _ramda.all)((0, _ramda.propEq)('isAward', false))(this.props.fund.fundPerformanceRatings))) {
        return null;
      }

      return _react2.default.createElement(_fund_awards_and_ratings_card2.default, {
        key: key,
        fundRatings: this.props.additionalRatings,
        fundPerformanceRatings: this.props.fund.fundPerformanceRatings,
        gaiaRedirectUrl: this.props.gaiaRedirectUrl,
        disclosure: this.props.fund.disclosures,
        breakpoint: this.props.breakpoint,
        tooltip: this.props.tooltip,
        visibleDataPoints: this.props.fund.visibleData.visibleDataPoints,
        cusip: this.props.cusip,
        fundAwards: fundAwards,
        parent: this.props.parent
      });
    }
  }, {
    key: "renderRiskIndicatorCard",
    value: function renderRiskIndicatorCard(key) {

      if (!_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_SRRI_INDICATOR') && !_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_SIMPLIFIED_SRRI_INDICATOR')) {
        return null;
      }

      if ((0, _ramda.isNil)(this.props.fund.shareClass.srriValue)) {
        return null;
      }

      return _react2.default.createElement(_risk_indicator_card2.default, {
        key: key,
        riskIndicatorValue: this.props.fund.shareClass.srriValue,
        breakpoint: this.props.breakpoint,
        gaiaRedirectUrl: this.props.gaiaRedirectUrl,
        simplifiedView: _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_SIMPLIFIED_SRRI_INDICATOR'),
        disclosure: this.props.fund.disclosures.pdpCardRiskIndicator,
        shouldAlwaysShowMore: _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'ALWAYS_SHOW_MORE_DISCLOSURES'),
        priipsHoldingPeriod: this.props.fund.priipsHoldingPeriod
      });
    }
  }, {
    key: "renderLipperRatingsCard",
    value: function renderLipperRatingsCard() {
      if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'FUND_RATINGS') && !(0, _functional_utility.isNilOrEmpty)(this.props.fund.shareClass.lipperRating) && this.props.fund.fundTypeCode === 'Mutual Fund') {
        return _react2.default.createElement(_lipper_ratings2.default, {
          lipperRating: this.props.fund.shareClass.lipperRating,
          lipperRatingEffectiveDate: this.props.fund.shareClass.lipperRatingEffectiveDate,
          peerGroupCategory: this.props.fund.shareClass.lipperRatingCategory,
          disclosure: this.props.fund.disclosures.pdpCardLipperRankings,
          breakpoint: this.props.breakpoint });
      }
    }
  }, {
    key: "renderMorningStarRatingsCard",
    value: function renderMorningStarRatingsCard() {
      if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'FUND_RATINGS') && this.props.fund.shareClass.morningstarRating && this.props.fund.shareClass.morningstarRating.length > 0) {
        return _react2.default.createElement(_morningstar_ratings2.default, {
          gaiaRedirectUrl: this.props.gaiaRedirectUrl,
          morningstarOverallRating: this.props.fund.shareClass.morningstarOverallRating,
          morningstarRating: this.props.fund.shareClass.morningstarRating,
          morningstarRatingEffectiveDate: this.props.fund.shareClass.morningstarRatingEffectiveDate,
          peerGroupCategory: this.props.fund.shareClass.morningstarRatingCategory,
          disclosure: this.props.fund.disclosures.pdpCardMorningstarRatings,
          analystDisclosure: this.props.fund.disclosures.pdpSummaryAnalystRatingPopUp,
          intl: this.props.intl,
          breakpoint: this.props.breakpoint });
      }
    }
  }, {
    key: "renderObjectiveCard",
    value: function renderObjectiveCard() {
      var objectiveCards = [];
      var fundContent = !(0, _functional_utility.isNilOrEmpty)(this.props.content) ? this.props.content.featuredContent : null;
      var borderRequired = false;
      var showFeaturedContentAndObjective = _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_FEATUREDCONTENT_AND_OBJECTIVE');
      if ((0, _ramda.isNil)(fundContent)) {
        fundContent = !(0, _functional_utility.isNilOrEmpty)(this.props.fund.fundContent) ? this.props.fund.fundContent.featuredCardContent : null;
        borderRequired = true;
      }

      if (fundContent instanceof Array) {
        fundContent = fundContent[0];
      }

      if (!(0, _functional_utility.isNilOrEmpty)(fundContent)) {
        objectiveCards.push(_react2.default.createElement(_featured_content_card2.default, { featuredCardContent: fundContent,
          disclosureText: this.props.fund.disclosures.pdpCardKeyPoints,
          breakpoint: this.props.breakpoint,
          borderRequired: borderRequired }));
      }

      if (((0, _functional_utility.isNilOrEmpty)(fundContent) || showFeaturedContentAndObjective) && !(0, _ramda.isNil)(this.props.fund.objective) && !_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HIDE_OVERVIEW_OBJECTIVE_CARD')) {
        objectiveCards.push(_react2.default.createElement(_objective_card2.default, { designedTo: this.props.fund.designedTo, objective: this.props.fund.objective,
          strategy: this.props.fund.strategy,
          disclosureText: this.props.fund.disclosures.pdpCardObjectiveBox,
          breakpoint: this.props.breakpoint }));
      }

      return objectiveCards;
    }
  }, {
    key: "renderGenericObjectiveCards",
    value: function renderGenericObjectiveCards() {
      var objectiveCards = [];
      var index = 0;

      var intl = this.props.intl;


      var investmentObjectiveLabel = _string_utility2.default.renderFormattedLabel("Investment Objective", "pdp-investment-objective-label", {
        fundType: this.props.fund.fundTypeCode,
        role: this.props.role
      });

      if (!(0, _ramda.isNil)(this.props.fund.investmentObjective)) {
        var cardContent = _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HIDE_BULLET_POINTS') ? this.props.fund.investmentObjective.split("<li>").join("<li style='list-style-type:none;'>").split("ul>").join("/div>") : this.props.fund.investmentObjective;
        objectiveCards.push(_react2.default.createElement(_generic_objective_card2.default, { key: index++, headerLabel: investmentObjectiveLabel,
          cardContent: cardContent,
          cardId: "investment-objective-card",
          breakpoint: this.props.breakpoint,
          dataTest: "pdpCardObjectiveBox",
          disclosureText: this.props.fund.disclosures.pdpCardObjectiveBox
        }));
      }

      if (!(0, _ramda.isNil)(this.props.fund.investorProfile)) {
        var investorProfileLabel = intl.formatMessage({
          id: "pdp-investor-profile-label",
          defaultMessage: "Investor Profile"
        });

        objectiveCards.push(_react2.default.createElement(_generic_objective_card2.default, { key: index++, headerLabel: investorProfileLabel,
          cardContent: this.props.fund.investorProfile,
          cardId: "investor-profile-card", breakpoint: this.props.breakpoint }));
      }

      if (!(0, _ramda.isNil)(this.props.fund.typicalInvestment)) {
        objectiveCards.push(_react2.default.createElement(_generic_objective_card2.default, { key: index++, headerLabel: "Typical Investment",
          cardContent: this.props.fund.typicalInvestment,
          cardId: "typical-investment-card", breakpoint: this.props.breakpoint }));
      }

      if (!(0, _ramda.isNil)(this.props.fund.investmentApproach) && _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_INVESTMENT_APPROACH')) {
        objectiveCards.push(_react2.default.createElement(_generic_objective_card2.default, { key: index++,
          headerLabel: intl.formatMessage({
            id: "pdp-investment-approach-label",
            defaultMessage: "Investment approach"
          }),
          cardContent: this.props.fund.investmentApproach,
          cardId: "investment-approach-card", breakpoint: this.props.breakpoint }));
      }

      if (!(0, _ramda.isNil)(this.props.fund.investmentPolicy) && _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_INVESTMENT_POLICY')) {
        objectiveCards.push(_react2.default.createElement(_generic_objective_card2.default, { key: index++,
          headerLabel: intl.formatMessage({
            id: "pdp-investment-policy-label",
            defaultMessage: "Investment policy"
          }),
          cardContent: this.props.fund.investmentPolicy,
          dataTest: "pdpCardInvestmentPolicyBelgium",
          disclosureText: this.props.fund.disclosures.pdpCardInvestmentPolicyBelgium,
          cardId: "investment-policy-card", breakpoint: this.props.breakpoint,
          shouldAlwaysShowMore: _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'ALWAYS_SHOW_MORE_DISCLOSURES') }));
      }

      if (!(0, _ramda.isNil)(this.props.fund.benchmarkUsesAndResemblance) && _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_BENCHMARK_USES_RESEMBLANCE')) {
        objectiveCards.push(_react2.default.createElement(_generic_objective_card2.default, { key: index++,
          headerLabel: intl.formatMessage({
            id: "pdp-benchmark-uses-resemblance-label",
            defaultMessage: "Benchmark uses and resemblance"
          }),
          cardContent: this.props.fund.benchmarkUsesAndResemblance,
          cardId: "benchmark-uses-resemblance-card", breakpoint: this.props.breakpoint }));
      }

      return objectiveCards;
    }
  }, {
    key: "renderTextOnlyKeyRiskCard",
    value: function renderTextOnlyKeyRiskCard() {

      var riskProfileLabel = _string_utility2.default.renderFormattedLabel("Risk Profile", "pdp-risk-profile-label", { role: this.props.role });

      if (!(0, _ramda.isNil)(this.props.fund.riskProfile) && !_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HIDE_RISK_PROFILE_CARD') && !_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_KEY_RISKS_CARD') && !this.props.fund.stringValueWrapper.showKeyRiskCard) {
        return _react2.default.createElement(_generic_objective_card2.default, { headerLabel: riskProfileLabel,
          cardContent: this.props.fund.riskProfile,
          cardId: "risk-profile-card", breakpoint: this.props.breakpoint });
      }
    }
  }, {
    key: "renderFundStatsCard",
    value: function renderFundStatsCard(key) {
      if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HIDE_FUND_STATS_FACTS')) {
        return null;
      }

      var shareClassIsOlderThanOneYear = this.props.fund.isShareClassMoreThanAnYearOld;

      var latestDividend = (0, _ramda.pathOr)(null, ["fund", "shareClass", "fundShareclassDividend"], this.props);
      var latestAnnualizedYield = latestDividend;

      if (!(0, _functional_utility.isNilOrEmpty)(latestDividend) && (0, _functional_utility.isNilOrEmpty)((0, _ramda.pathOr)(null, ["annualizedDividendYieldPercentage"], latestDividend)) && !(0, _functional_utility.isNilOrEmpty)(this.props.fundDistribution)) {
        latestAnnualizedYield = this.props.fundDistribution[0];
      }

      var latestAvailableDistributionHistory = (0, _ramda.pathOr)(null, ["historicalData", "latestAvailableDistributionHistory"], this.props);

      if (!(0, _functional_utility.isNilOrEmpty)(latestAvailableDistributionHistory)) {
        latestAnnualizedYield = latestAvailableDistributionHistory;
      }

      return _react2.default.createElement(_fund_stats_card2.default, {
        key: key,
        nav: this.props.fund.shareClass.nav,
        navDecimalPoints: (0, _ramda.pathOr)(2, ["shareClass", "nav", "navDecimalPoints"], this.props.fund),
        sharesOutstanding: this.props.fund.shareClass.sharesOutstanding,
        fundShareClassValuationEffectiveDate: this.props.fund.shareClass.fundShareClassValuationDate,
        fundValuationDate: this.props.fund.fundValuationDate,
        marketNav: this.props.fund.marketNav,
        netGrossAssetClass: this.props.fund.shareClass.netGrossAssetClass,
        grossAssetClassEffectiveDate: this.props.fund.shareClass.grossAssetClassEffectiveDate,
        ytdPercentage: this.props.fund.shareClass.ytdPercentage,
        marketPriceReturn: this.props.fund.shareClass.marketPriceReturn,
        fundTypeCode: this.props.fund.fundTypeCode,
        fundName: this.props.fund.name,
        currencyCode: this.props.fund.currencyCode,
        shareclassCurrencyCode: this.props.fund.shareClass.currencyCode,
        marketPrice: this.props.fund.shareClass.marketPrice,
        proxyOverlap: this.props.fund.shareClass.proxyOverlap,
        proxyTrackingError: this.props.fund.shareClass.proxyTrackingError,
        proxyPerfRiskEffectiveDate: this.props.fund.shareClass.proxyPerfRiskEffectiveDate,
        exchangeVolume: this.props.fund.shareClass.exchangeVolume,
        totalAsset: this.props.fund.totalAsset,
        leverageRatio: this.props.fund.leverageRatio,
        numberOfHoldings: this.props.fund.numberOfHoldings,
        numberOfHoldingsEffectiveDate: this.props.fund.numberOfHoldingsEffectiveDate,
        numberOfInvestments: this.props.fund.numberOfInvestments,
        numberOfInvestmentsEffectiveDate: this.props.fund.numberOfInvestmentsEffectiveDate,
        visibleData: this.props.fund.visibleData,
        secYield: this.props.fund.shareClass.secYield,
        yieldMonthEnd: this.props.fund.shareClass.yieldMonthEnd,
        nonFairNav: this.props.fund.shareClass.nonFairNav,
        threePMNav: this.props.fund.shareClass.threePMNav,
        dailyYield: this.props.fund.shareClass.dailyYield,
        wal: this.props.fund.shareClass.wal,
        wam: this.props.fund.shareClass.wam,
        liquidityDailyPercentage: this.props.fund.liquidityDailyPercentage,
        liquidityWeeklyPercentage: this.props.fund.liquidityWeeklyPercentage,
        dailyDividendFactor: this.props.fund.shareClass.dailyDividendFactor,
        intraDayNav: this.props.fund.shareClass.intraDayNav,
        disclosure: this.props.fund.disclosures,
        breakpoint: this.props.breakpoint,
        tooltip: this.props.tooltip,
        fundIndustryCreditRatings: this.props.fund.fundIndustryCreditRatings,
        country: this.props.country,
        ukReportingIndicator: this.props.fund.shareClass.ukReportingIndicator,
        fiscalYearEnd: this.props.fund.fiscalYearEnd,
        yieldAmount: (0, _ramda.pathOr)(null, ["fund", "shareClass", "secYield", "yieldAmount"], this.props),
        latestDividend: latestDividend,
        latestAnnualizedYield: latestAnnualizedYield,
        latestDividendExDate: (0, _ramda.pathOr)(null, ["historicalData", "latestAvailableDistributionHistory", "exDate"], this.props),
        latestDividendRecordDate: (0, _ramda.pathOr)(null, ["historicalData", "latestAvailableDistributionHistory", "recordDate"], this.props),
        exDividendDate: this.props.fund.shareClass.exDividendDate,
        incomeDistributionFrequency: this.props.fund.shareClass.incomeDistributionFrequency,
        incomeDistributionDate: this.props.fund.shareClass.incomeDistributionDate,
        role: this.props.role,
        aum: this.props.fund.aum,
        shareClassPrice: this.props.fund.shareClass.fundShareClassPrice,
        apacYield: (0, _ramda.pathOr)(null, ["fund", "shareClass", "apacYield"], this.props),
        isFundMoreThanAYearOld: this.props.fund.isFundMoreThanAYearOld,
        isShareclassMoreThanAYearOld: shareClassIsOlderThanOneYear,
        replicationMethodName: this.props.fund.replicationMethodTypeName,
        fundRebalancingFrequencyName: this.props.fund.fundRebalancingFrequencyName,
        securityLendingFlag: (0, _ramda.pathOr)(null, ["fund", "stringValueWrapper", "securityLendingFlag"], this.props),
        numberFormat: this.props.fund.numberFormat,
        intl: this.props.intl,
        companyBrokerNames: this.props.fund.companyBrokerNames,
        totalAnnualDividend: this.props.fund.totalAnnualDividend,
        potentialGearingRange: this.props.fund.potentialGearingRange,
        actualGearing: (0, _ramda.isNil)(this.props.fund.shareClass.nav) ? null : this.props.fund.shareClass.nav.gearingPercentage,
        currentSharePrice: this.props.fund.currentSharePrice,
        currentSharePriceDate: this.props.fund.currentSharePriceDate,
        isDisplayAumInUsd: this.props.fund.isDisplayAumInUsd,
        etfSecYield: this.props.fund.shareClass.etfSecYield,
        verifiedIntraDayValue: this.props.fund.shareClass.verifiedIntraDayValue,
        portfolioStatisticalAnalysis: this.props.fund.portfolioStatisticalAnalysis,
        isSMA: this.props.fund.isSMA,
        netYieldToMaturity: this.props.fund.shareClass.netYieldToMaturity,
        netYieldToMaturityEffectiveDate: this.props.fund.shareClass.netYieldToMaturityEffectiveDate,
        grossYieldToMaturity: this.props.fund.grossYieldToMaturity,
        fundDurationMaturity: this.props.fund.fundDurationMaturity,
        fund: this.props.fund
      });
    }
  }, {
    key: "renderFundStatsFundFacts",
    value: function renderFundStatsFundFacts(key) {

      if (this.props.breakpoint === 3) {
        return _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "div",
            { id: "RiskIndicatorCard", className: "float-left width-percent-100" },
            this.renderRiskIndicatorCard(key + 'srri-card')
          ),
          _react2.default.createElement(
            "div",
            { id: "FundAwardsAndRatingsCard", className: "float-left width-percent-100" },
            this.renderFundAwardsAndRatingsCard(key + 'fund-awards')
          ),
          _react2.default.createElement(
            "div",
            { id: "FundFactsCard", className: "float-left width-percent-49 margin-right-14 print-full-width" },
            _react2.default.createElement(
              "div",
              {
                className: "print-display-inline-block print-width-50 facts-min-investments" },
              this.renderFundFactsCard()
            ),
            _react2.default.createElement(
              "div",
              { "data-testid": "print-minimum-investments",
                className: "print-display-inline-block print-width-50 facts-min-investments" },
              this.showMinimumInvestmentsCard()
            ),
            _react2.default.createElement(
              "div",
              { "data-testid": "print-fund-charges",
                className: "print-display-inline-block print-width-50 facts-charges" },
              this.showFundChargesCard()
            )
          ),
          _react2.default.createElement(
            "div",
            { id: "FundStatsCard", className: "float-left width-percent-49" },
            this.renderFundStatsCard(key + 'fund-stats')
          ),
          this.hideFundCarbonEmissionsCard() && _react2.default.createElement(
            "div",
            { id: "FundCarbonEmissionsCard", className: "width-percent-49" },
            this.renderFundCarbonEmissionsCard()
          )
        );
      } else {
        var sampleWithdrawalCard = [];
        var fundFactsMinimumInvestmentAndStatsCard = [this.renderFundAwardsAndRatingsCard(key + 'fund-awards'), this.renderRiskIndicatorCard(key + 'srri-card'), _react2.default.createElement(
          "div",
          {
            key: "fundFactsKey",
            "data-testid": "fund-facts-wrapper",
            className: "print-display-inline-block print-width-50 facts-min-investments"
          },
          this.renderFundFactsCard()
        ), _react2.default.createElement(
          "div",
          {
            key: "minimumInvestmentKey",
            "data-testid": "print-minimum-investments",
            className: "print-display-inline-block print-width-50 facts-min-investments",
            style: { "display": "none" }
          },
          this.showMinimumInvestmentsCard()
        ), _react2.default.createElement(
          "div",
          {
            key: "fundChargesKey",
            "data-testid": "print-fund-charges",
            className: "print-display-inline-block print-width-50",
            style: { "display": "none" }
          },
          this.showFundChargesCard()
        )].concat(sampleWithdrawalCard, [this.renderFundStatsCard(key + 'fund-stats')]);

        return _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "div",
            { "data-testid": "fundFactsAndMinInvestment" },
            fundFactsMinimumInvestmentAndStatsCard
          ),
          _react2.default.createElement(
            "div",
            { className: "print-page-break print-hide", style: { "height": "auto" } },
            this.showMinimumInvestmentsCard()
          ),
          _react2.default.createElement(
            "div",
            { className: "print-page-break print-hide", style: { "height": "auto" } },
            this.showFundChargesCard()
          ),
          this.hideFundCarbonEmissionsCard() && _react2.default.createElement(
            "div",
            { className: "print-page-break", style: { "height": "auto" } },
            this.renderFundCarbonEmissionsCard()
          )
        );
      }
    }
  }, {
    key: "hideFundCarbonEmissionsCard",
    value: function hideFundCarbonEmissionsCard() {
      var retVal = true;
      if ((0, _functional_utility.isNilOrEmpty)(this.props.fund.fundCarbonEmission) || !_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_CARBON_EMISSION_CARD')) {
        retVal = false;
      }
      return retVal;
    }
  }, {
    key: "renderFundCarbonEmissionsCard",
    value: function renderFundCarbonEmissionsCard() {
      return _react2.default.createElement(_fund_carbon_emissions2.default, { breakpoint: this.props.breakpoint,
        fundCarbonEmission: this.props.fund.fundCarbonEmission,
        numberFormat: this.props.fund.numberFormat,
        disclosure: this.props.fund.disclosures.pdpCardCarbonEmission });
    }
  }, {
    key: "renderFundVideoCard",
    value: function renderFundVideoCard() {

      if (_collection_utility.CollectionUtility.includes(_constants2.default.getExcludeRolesFundVideoCardConstants(), this.props.role)) {
        return null;
      }

      var relatedVideo = this.props.content ? this.props.content.fundVideo : null;
      if ((0, _functional_utility.isNilOrEmpty)(relatedVideo) && !((0, _functional_utility.isDataEmpty)(this.props.fund.fundDocuments) || (0, _functional_utility.isDataEmpty)(this.props.fund.fundDocuments.fundVideo))) {
        relatedVideo = this.props.fund.fundDocuments.fundVideo[0];
      }

      if (!(0, _ramda.isNil)(relatedVideo)) {
        if (this.props.active !== "overview" && typeof window.videojs === 'function' && !(0, _ramda.isNil)(document.getElementById('fund-video-player'))) {
          window.videojs('fund-video-player').pause();
        }
        return _react2.default.createElement(
          "div",
          { className: "print-hide" },
          _react2.default.createElement(
            _card_component2.default,
            {
              dataTest: "fund-video-card",
              headerTitle: relatedVideo.title,
              headerTitleId: 'fund-video-title',
              breakpoint: this.props.breakpoint
            },
            _react2.default.createElement(
              "div",
              { "data-testid": "fund-video-component" },
              _react2.default.createElement(_fund_video2.default, { fundVideo: relatedVideo, window: this.props.window })
            )
          )
        );
      }
    }
  }, {
    key: "renderFundWebcastCard",
    value: function renderFundWebcastCard() {
      if ((0, _ramda.isNil)(this.props.fund.fundContent) || (0, _functional_utility.isNilOrEmpty)(this.props.fund.fundContent.fundWebcast) || _collection_utility.CollectionUtility.includes(_constants.EXCLUDEROLES_FUND_WEBCAST_CARD, this.props.role) || _location_service2.default.isMobileInsight(this.props.basePath)) {
        return null;
      }
      return _react2.default.createElement(
        "div",
        { className: "print-hide" },
        _react2.default.createElement(
          _card_component2.default,
          {
            dataTest: "fund-webcast-card",
            headerTitle: 'Webcast',
            headerTitleId: 'fund-webcast-title',
            breakpoint: this.props.breakpoint
          },
          _react2.default.createElement(
            "div",
            { "data-testid": "fund-webcast-component" },
            _react2.default.createElement(_fund_webcast2.default, { channelId: this.props.fund.fundContent.fundWebcast.channelId,
              commId: this.props.fund.fundContent.fundWebcast.commId })
          )
        )
      );
    }
  }, {
    key: "renderHowToInvestCard",
    value: function renderHowToInvestCard() {
      if (!_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, "SHOW_HOW_TO_INVEST_CARD")) {
        return null;
      } else {
        return _react2.default.createElement(_how_to_invest_card2.default, { breakpoint: this.props.breakpoint,
          gaiaRedirectUrl: this.props.gaiaRedirectUrl,
          intl: this.props.intl
        });
      }
    }
  }, {
    key: "renderETFAuthorisedParticipantsCard",
    value: function renderETFAuthorisedParticipantsCard() {
      return _react2.default.createElement(_distributor_table_component2.default, { data: this.props.fund.stringValueWrapper.authorizedParticipants,
        breakpoint: this.props.breakpoint,
        disclosure: this.props.fund.disclosures.pdpCardAuthorizedParticipant,
        headerTitleKey: "pdp-overview-authorized-participants-header-label",
        headerTitleId: "fund-authorized-participants-title" });
    }
  }, {
    key: "renderETFMarketMakerCard",
    value: function renderETFMarketMakerCard() {
      return _react2.default.createElement(_distributor_table_component2.default, { data: this.props.fund.stringValueWrapper.marketMakers,
        breakpoint: this.props.breakpoint,
        disclosure: this.props.fund.disclosures.pdpCardMarketMaker,
        headerTitleKey: "pdp-overview-market-makers-header-label",
        headerTitleId: "fund-market-makers-title" });
    }
  }, {
    key: "renderFundManagersCard",
    value: function renderFundManagersCard() {
      if (this.props.fund.fundTypeCode === '529 Plans') {
        return null;
      }

      if ((0, _functional_utility.isDataEmpty)(this.props.fund.fundManagers) || _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HIDE_FUND_MANAGERS')) {
        return null;
      }

      return _react2.default.createElement(_fund_managers_card2.default, { gaiaRedirectUrl: this.props.gaiaRedirectUrl,
        fundManagers: this.props.fund.fundManagers,
        breakpoint: this.props.breakpoint,
        country: this.props.country,
        role: this.props.role,
        language: this.props.language,
        disclosures: this.props.fund.disclosures,
        formattingRules: this.props.fund.visibleData.formattingRules,
        hideFundManagerBioLinks: _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HIDE_FUND_MANAGER_BIOLINKS'),
        isCIFMFund: _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HIDE_FUND_MANAGERS_INFO'),
        hideShadowImage: _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HIDE_FUND_MANAGER_BIO_IMAGE'),
        isSMA: this.props.fund.isSMA,
        title: "Portfolio Managers",
        titleID: "pdp-overview-fundmanager-header-label",
        disclosureId: "pdpCardFundManager",
        testId: "fund-manager",
        headerTitleID: "fundManagerCardHeaderId"
      });
    }
  }, {
    key: "renderInvestmentAdvisorCard",
    value: function renderInvestmentAdvisorCard() {
      if (this.props.fund.fundTypeCode === '529 Plans') {
        return null;
      }

      if ((0, _functional_utility.isDataEmpty)(this.props.fund.investmentAdvisors) || _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HIDE_FUND_MANAGERS')) {
        return null;
      }

      return _react2.default.createElement(_fund_managers_card2.default, { gaiaRedirectUrl: this.props.gaiaRedirectUrl,
        fundManagers: this.props.fund.investmentAdvisors,
        breakpoint: this.props.breakpoint,
        country: this.props.country,
        role: this.props.role,
        language: this.props.language,
        disclosures: this.props.fund.disclosures,
        formattingRules: this.props.fund.visibleData.formattingRules,
        hideFundManagerBioLinks: _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HIDE_FUND_MANAGER_BIOLINKS'),
        isCIFMFund: _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HIDE_FUND_MANAGERS_INFO'),
        hideShadowImage: _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HIDE_FUND_MANAGER_BIO_IMAGE'),
        isSMA: this.props.fund.isSMA,
        title: "Investment advisor",
        titleID: "pdp-overview-investment-advisors-header-label",
        disclosureId: "pdpCardInvestmentAdvisor",
        testId: "investment-advisor",
        headerTitleID: "investmentAdvisorsCardHeaderId",
        hidePosition: true
      });
    }
  }, {
    key: "renderSalesCharges",
    value: function renderSalesCharges() {

      return _collection_utility.CollectionUtility.includes((this.props.fund.visibleData || {}).visibleDataPoints, 'CHARGES_CARD') && _react2.default.createElement(_charges_card2.default, {
        fees: this.props.fund.shareClass.fees,
        expenses: this.props.fund.shareClass.expenses,
        disclosures: this.props.fund.disclosures,
        visibleData: this.props.fund.visibleData,
        breakpoint: this.props.breakpoint,
        country: this.props.country
      });
    }
  }, {
    key: "renderFormattedLabel",
    value: function renderFormattedLabel(defaultLabel, key) {
      return _react2.default.createElement(_reactIntl.FormattedMessage, { id: key, defaultMessage: defaultLabel });
    }
  }, {
    key: "renderRegisteredCountriesCard",
    value: function renderRegisteredCountriesCard() {
      return _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, "REGISTERED_COUNTRIES") && _react2.default.createElement(_registered_country_component2.default, { data: this.props.fund.shareClass.registeredCountries,
        breakpoint: this.props.breakpoint,
        disclosure: this.props.fund.disclosures.pdpCardRegisteredCountries });
    }
  }, {
    key: "renderListOfExchangeCard",
    value: function renderListOfExchangeCard() {
      return _react2.default.createElement(_exchanges_card2.default, { data: this.props.fund.shareClass.fundTradingLine, disclosures: this.props.fund.disclosures, breakpoint: this.props.breakpoint,
        activeTab: this.props.active });
    }
  }, {
    key: "renderSideColumn",
    value: function renderSideColumn() {
      var printClassNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var breakpoint = this.props.breakpoint;

      var breakpoint3Classes = breakpoint === 3 ? "col-md-12 col-lg-12 col-xlg-12 margin-left-0" : "col-md-4 col-lg-3 col-xlg-3 padding-all-0";
      var mobileClasses = breakpoint < 3 ? "margin-all-0" : "";

      return _react2.default.createElement(
        "div",
        { "data-testid": "overview-side-column",
          className: "col-xs-12 col-sm-12 " + breakpoint3Classes + " " + mobileClasses + " " + printClassNames + " print-full-width" },
        this.renderFundStatsFundFacts(printClassNames)
      );
    }
  }, {
    key: "renderBoardOfDirectors",
    value: function renderBoardOfDirectors() {
      return _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, "SHOW_BOARD_OF_DIRECTORS") && _react2.default.createElement(_board_of_directors_card2.default, {
        boardOfDirectors: this.props.fund.boardOfDirectors,
        breakpoint: this.props.breakpoint
      });
    }
  }, {
    key: "renderPortfolioInsightCard",
    value: function renderPortfolioInsightCard(relatedInsights, contributorsPrefixBy, contributorsInSingleLine, cardId, cardTitle) {
      if ((0, _functional_utility.isNilOrEmpty)(relatedInsights) || !_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, "SHOW_PORTFOLIO_INSIGHTS_CARD")) {
        return null;
      } else {
        return _react2.default.createElement(_portfolio_insights2.default, {
          gaiaRedirectUrl: this.props.gaiaRedirectUrl,
          breakpoint: this.props.breakpoint,
          relatedInsights: relatedInsights,
          contributorsPrefixBy: contributorsPrefixBy,
          contributorsInSingleLine: contributorsInSingleLine,
          cardId: cardId,
          cardTitle: cardTitle,
          intl: this.props.intl,
          hideShadowImage: _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HIDE_FUND_MANAGER_BIO_IMAGE')
        });
      }
    }
  }, {
    key: "outputCardsWithOrder",
    value: function outputCardsWithOrder(insights) {
      var ordering = this.getOverviewOrdering(insights);
      return ordering.map(function (ordering) {
        return ordering;
      });
    }
  }, {
    key: "getOverviewOrdering",
    value: function getOverviewOrdering(insights) {
      if (this.props.country === 'au' && this.props.role !== 'liq') {
        return [this.renderObjectiveCard(), this.renderGenericObjectiveCards(), this.renderFundVideoCard(), this.renderFundManagersCard(), this.renderInvestmentAdvisorCard(), this.renderTextOnlyKeyRiskCard()];
      } else if (this.props.country === 'tw' && this.props.role !== 'liq') {
        return [this.renderObjectiveCard(), this.renderPortfolioInsightCard(insights.aemMarketingTeamArticle, insights.contributorsPrefixBy, false, "marketing-team-article-card", _string_utility2.default.renderFormattedLabel("Article by Marketing Team", "marketing-team-article-card-title")), this.renderGenericObjectiveCards(), this.renderFundVideoCard(), this.renderFundManagersCard(), this.renderETFAuthorisedParticipantsCard(), this.renderETFMarketMakerCard(), this.renderInvestmentAdvisorCard(), this.renderDividendPolicyCard()];
      } else if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HIDE_LEFT_SIDE_OVERVIEW_CARDS')) {
        return [];
      } else if (this.props.fund.fundTypeCode === 'INVESTMENT_TRUST') {
        return [this.renderTrustInBriefCarousel(), this.renderObjectiveCard(), this.renderGenericObjectiveCards(), this.renderFundWebcastCard(), this.renderPortfolioInsightCard(insights.managerInsights, insights.contributorsPrefixBy, true, "portfolio-insight-card", _string_utility2.default.renderFormattedLabel("Insights from Portfolio Manager", "portfolio-manager-insight-card-title")), this.renderPortfolioInsightCard(insights.teamInsights, insights.contributorsPrefixBy, false, "portfolio-insight-team-card", _string_utility2.default.renderFormattedLabel("Insights from the team", "team-insight-card-title")), this.renderFundVideoCard(), this.renderFundManagersCard(), this.renderInvestmentAdvisorCard(), this.renderHowToInvestCard(), this.renderTextOnlyKeyRiskCard(), this.renderFinancialCalendarCard(), this.renderKeyRisksCard, this.renderBoardOfDirectors(), this.renderSalesCharges(), this.renderMorningStarRatingsCard(), this.renderLipperRatingsCard(), this.renderRegisteredCountriesCard()];
      } else {
        return [this.renderObjectiveCard(), this.renderPortfolioInsightCard(insights.aemMarketingTeamArticle, insights.contributorsPrefixBy, false, "marketing-team-article-card", _string_utility2.default.renderFormattedLabel("Article by Marketing Team", "marketing-team-article-card-title")), _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.formattingRules, "MOVE_VIDEO_CARD_ABOVE_OBJECTIVE_CARD") ? this.renderFundVideoCard() : null, this.renderGenericObjectiveCards(), this.renderTextOnlyKeyRiskCard(), this.renderKeyRisksCard, _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, "LIST_OF_EXCHANGES") ? this.renderListOfExchangeCard() : null, _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, "SHOW_AUTHORISED_PARTICIPANTS") && this.renderAuthorisedParticipantsCard, this.renderFundWebcastCard(), this.renderPortfolioInsightCard(insights.managerInsights, insights.contributorsPrefixBy, true, "portfolio-insight-card", _string_utility2.default.renderFormattedLabel("Insights from Portfolio Manager", "portfolio-manager-insight-card-title")), this.renderPortfolioInsightCard(insights.teamInsights, insights.contributorsPrefixBy, false, "portfolio-insight-team-card", _string_utility2.default.renderFormattedLabel("Insights from the team", "team-insight-card-title")), this.renderPortfolioInsightCard(insights.aemManagerInsights, insights.contributorsPrefixBy, false, "portfolio-insight-card", _string_utility2.default.renderFormattedLabel("Insights from Portfolio Manager", "portfolio-manager-insight-card-title")), this.renderPortfolioInsightCard(insights.aemTeamInsights, insights.contributorsPrefixBy, false, "portfolio-insight-team-card", _string_utility2.default.renderFormattedLabel("Insights from the team", "team-insight-card-title")), !_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.formattingRules, "MOVE_VIDEO_CARD_ABOVE_OBJECTIVE_CARD") ? this.renderFundVideoCard() : null, this.renderFundManagersCard(), this.renderInvestmentAdvisorCard(), this.renderBoardOfDirectors(), this.renderSalesCharges(), this.renderInvestmentOnRiskCard(), this.renderDividendPolicyCard(), this.renderMorningStarRatingsCard(), this.renderLipperRatingsCard(), this.renderRegisteredCountriesCard()];
      }
    }
  }, {
    key: "render",
    value: function render() {
      var insightsData = this.filterInsightsCardData();
      return _react2.default.createElement(
        "div",
        null,
        this.renderSideColumn("print-display display-none"),
        _react2.default.createElement(
          "div",
          {
            "data-testid": "overview-column",
            className: "col-xs-12 col-sm-12 " + (this.props.breakpoint === 3 ? "col-md-12 col-lg-12 col-xlg-12" : "col-md-8 col-lg-9 col-xlg-9") + " " + (this.props.breakpoint >= 4 ? "padding-right-30" : "") + (this.props.breakpoint < 3 ? " margin-all-0 padding-all-0" : "") + " print-full-width" },
          this.outputCardsWithOrder(insightsData)
        ),
        this.renderSideColumn("print-hide screen-visible")
      );
    }
  }, {
    key: "filterInsightsCardData",
    value: function filterInsightsCardData() {
      var managerInsights = void 0,
          teamInsights = null,
          aemManagerInsights = null,
          aemTeamInsights = null,
          aemMarketingTeamArticle = null,
          contributorsPrefixBy = true;
      var relatedInsights = ((this.props.content || {}).relatedInsights || {}).relatedInsights || [];
      var self = this;
      if (!(0, _ramda.isNil)(this.props.fund.fundContent) && !(0, _ramda.isNil)(this.props.fund.fundContent.relatedInsights)) {
        managerInsights = this.props.fund.fundContent.relatedInsights.filter(function (insight) {
          return insight.contentType === "NPE - Article";
        });
        teamInsights = this.props.fund.fundContent.relatedInsights.filter(function (insight) {
          return insight.contentType === "NPE - Article - team";
        });
      } else if (!(0, _ramda.isEmpty)(relatedInsights)) {
        aemManagerInsights = [];
        aemTeamInsights = [];
        aemMarketingTeamArticle = [];
        relatedInsights.map(function (insight) {
          if (!(0, _ramda.isNil)(insight)) {
            if ((0, _ramda.isNil)(insight.offDate) || (0, _date_formatter.fromDateIsAfterToDate)(insight.offDate, (0, _moment2.default)(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD')) {
              if (insight.contentType === 'NPE Article by Portfolio Manager') {
                aemManagerInsights.push(self.updateRelatedInsightDataForAem(insight));
              } else if (insight.contentType === 'NPE Article by Insights Team') {
                aemTeamInsights.push(self.updateRelatedInsightDataForAem(insight));
              } else if (insight.contentType === 'NPE Article by Marketing Team') {
                aemMarketingTeamArticle.push(self.updateRelatedInsightDataForAem(insight));
              }
            }
          }
        });
        contributorsPrefixBy = false;
        aemManagerInsights = self.sortBasedOnPublishedDate(aemManagerInsights);
        aemTeamInsights = self.sortBasedOnPublishedDate(aemTeamInsights);
        aemMarketingTeamArticle = self.sortBasedOnPublishedDateReturnLatest(aemMarketingTeamArticle);
      }
      return {
        managerInsights: managerInsights,
        teamInsights: teamInsights,
        aemManagerInsights: aemManagerInsights,
        aemTeamInsights: aemTeamInsights,
        aemMarketingTeamArticle: aemMarketingTeamArticle,
        contributorsPrefixBy: contributorsPrefixBy
      };
    }
  }, {
    key: "updateRelatedInsightDataForAem",
    value: function updateRelatedInsightDataForAem(insight) {
      // update the object to match the key names like existing OWCS's insight card data
      insight.pageTitle = insight.title;
      insight.contributorName = insight.contributors;
      (insight.contributorName || []).map(function (cont) {
        return cont.name = cont.contributorName;
      });
      return insight;
    }
  }, {
    key: "sortBasedOnPublishedDate",
    value: function sortBasedOnPublishedDate(data) {
      return data.sort(function (left, right) {
        return _moment2.default.utc(right.publishedDate).diff(_moment2.default.utc(left.publishedDate));
      });
    }
  }, {
    key: "sortBasedOnPublishedDateReturnLatest",
    value: function sortBasedOnPublishedDateReturnLatest(data) {
      data.sort(function (left, right) {
        return _moment2.default.utc(right.publishedDate).diff(_moment2.default.utc(left.publishedDate));
      });
      if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, "SHOW_OVERVIEW_MULTI_MARKETING_ARTICLES")) {
        return data.slice(0, 5);
      }
      return data.slice(0, 1);
    }
  }, {
    key: "renderKeyRisksCard",
    get: function get() {
      if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, "SHOW_KEY_RISKS_CARD") || this.props.fund.stringValueWrapper.showKeyRiskCard) {
        return _react2.default.createElement(_key_risks_card2.default, {
          breakpoint: this.props.breakpoint,
          keyRisksText: this.props.fund.fundMarketingTextLanguageTranslationText,
          riskSecuritiesString: this.props.fund.riskSecuritiesString,
          fundType: this.props.fund.fundTypeCode
        });
      }
    }
  }, {
    key: "renderAuthorisedParticipantsCard",
    get: function get() {
      if ((0, _functional_utility.isNilOrEmpty)(this.props.fund.authorisedParticipants)) {
        return null;
      }

      return _react2.default.createElement(_party_role_name_listing_card2.default, {
        data: this.props.fund.authorisedParticipants,
        breakpoint: this.props.breakpoint,
        id: "fund-authorised-participants",
        headerTitle: _string_utility2.default.renderFormattedLabel("Authorised participants", "pdp-overview-authorised-participants-header-label")
      });
    }
  }]);

  return FundOverview;
}(_react2.default.Component);

exports.default = (0, _reactIntl.injectIntl)(FundOverview, { withRef: true });